module.exports = {
	"config": {
		"siteTitle": "Henry Vo on the Web",
		"siteDescription": "Trying to crawl through life as a webdev",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"title": "Error 404",
				"layout": "error",
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.jsx",
				"ext": "jsx",
				"name": "about",
				"extname": ".jsx",
				"basename": "about.jsx",
				"dirname": "",
				"stem": "about",
				"path": "about.jsx"
			},
			"requirePath": "about.jsx",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-02-01-indian-traffic",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-02-01-indian-traffic",
				"stem": "index",
				"path": "articles/2017-02-01-indian-traffic/index.md"
			},
			"requirePath": "articles/2017-02-01-indian-traffic/index.md",
			"path": "/indian-traffic/",
			"data": {
				"title": "Indian Traffic",
				"date": "2017-02-01",
				"layout": "post",
				"path": "/indian-traffic/",
				"description": "Adventures abroad"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-01-subtle-art",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-01-subtle-art",
				"stem": "index",
				"path": "articles/2017-04-01-subtle-art/index.md"
			},
			"requirePath": "articles/2017-04-01-subtle-art/index.md",
			"path": "/code-part-1/",
			"data": {
				"title": "Code: The Hidden Language of Computer Hardware and Software",
				"date": "2017-04-01",
				"layout": "post",
				"path": "/code-part-1/",
				"description": "I read books? Part one"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-05-05-the-beginning",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-05-05-the-beginning",
				"stem": "index",
				"path": "articles/2017-05-05-the-beginning/index.md"
			},
			"requirePath": "articles/2017-05-05-the-beginning/index.md",
			"path": "/the-beginning/",
			"data": {
				"title": "The beginning of a (hopefully) long journey",
				"date": "2017-05-05",
				"layout": "post",
				"path": "/the-beginning/",
				"description": "How did I wind up here?"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "blog.jsx",
				"ext": "jsx",
				"name": "blog",
				"extname": ".jsx",
				"basename": "blog.jsx",
				"dirname": "",
				"stem": "blog",
				"path": "blog.jsx"
			},
			"requirePath": "blog.jsx",
			"path": "/blog/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "components.jsx",
				"ext": "jsx",
				"name": "components",
				"extname": ".jsx",
				"basename": "components.jsx",
				"dirname": "",
				"stem": "components",
				"path": "components.jsx"
			},
			"requirePath": "components.jsx",
			"path": "/components/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 384
// module chunks = 0